import React, { useEffect, useState } from 'react'
import { get } from 'lodash'
import { CheckCircleIcon } from '@heroicons/react/solid'
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar'
import Button from 'components/Common/Button'
import greenEllipse from 'assets/images/greenEllipse.svg'
import flag from 'assets/images/flag.svg'
import fire from 'assets/images/fire.svg'
import 'react-circular-progressbar/dist/styles.css'
import { ROLES } from 'config'
import { navigateTo } from 'utils/helper'

const Assessment = ({ goals, selectedGoal, addEditAssessmentAction, progress }) => {
  let userGoals = get(goals, 'getUserGoals', [])

  const [selectedAssessments, setSelectedAssessments] = useState([])
  const [assessmentList, setAssessmentList] = useState([])

  useEffect(() => {
    addEditAssessmentAction({ type: 'sales_assessment' })
  }, [addEditAssessmentAction])

  useEffect(() => {
    if (userGoals) {
      const activeGoals = userGoals.filter((data) => data?.isActiveGoal)

      const assessmentList = userGoals.map((userGoals) => JSON.parse(userGoals?.assessments))

      const assessments = get(activeGoals, `${selectedGoal}.assessments`)
      if (assessments) {
        const assessment = JSON.parse(assessments)
        setSelectedAssessments(assessment)
      } else {
        setSelectedAssessments([])
      }
      setAssessmentList(assessmentList)
    }
  }, [selectedGoal, goals, userGoals])

  return (
    <>
      <div>
        {userGoals.map((goal) => {
          return (
            <div>
              {goal.isTopGoal && goal.isActiveGoal ? (
                <div className="flex flex-column">
                  <span>
                    <CheckCircleIcon className="w-[18.24px] h-[18.24px] inline" />
                    <p className="text-sm	text-silver-darker font-bold inline">Top Goal</p>
                  </span>
                  <div></div>
                </div>
              ) : (
                ''
              )}
            </div>
          )
        })}
        <div className="items-center justify-center pb-12 mt-10 flex">
          <div className="max-w-[412px] w-full space-y-8">
            <div className="flex justify-center w-full items-center flex-col">
              <div
                style={{ width: 87.4, height: 87.4 }}
                className="origin-center static cursor-pointer"
                onClick={() =>
                  navigateTo(ROLES.BUSINESS_OWNER, `assessmentQuestion/sales_assessment`)
                }
              >
                <CircularProgressbarWithChildren
                  className="w-[87.4px] h-[87.4px] static"
                  value={progress}
                  circleRatio={0.94}
                  styles={buildStyles({
                    rotation: 0.36,
                    strokeLinecap: 'butt',
                    trailColor: 'primary-disabled',
                    pathColor: '#5BBAB9',
                  })}
                >
                  <div className="relative">
                    <img className="w-[65px] h-[65px]" src={greenEllipse} alt="green circle" />
                    <img
                      className="w-[44.68px] h-[49.19px] absolute top-2 left-[15%]"
                      src={flag}
                      alt="flag"
                      color="text-primary"
                    />
                    <div className="absolute top-10 right-[-18%]">
                      <img src={fire} width={'21.88'} height={'25px'} alt="fire" />
                    </div>
                  </div>
                </CircularProgressbarWithChildren>
              </div>
              <div className="text-center mb-7">
                <span className="text-primary-text text-base	font-primary font-bold">
                  {selectedAssessments[0]}
                </span>
              </div>
              <Button label={'Playbooks'} variant="primary" className="w-full" />
            </div>

            <div className="grid grid-cols-12 gap-2">
              {assessmentList &&
                assessmentList?.map((assessments, index) => {
                  return (
                    <div
                      className={`${
                        index === 0
                          ? 'col-span-12 flex flex-col items-center'
                          : 'flex flex-col col-span-6 items-center mt-10'
                      }`}
                    >
                      <div style={{ width: 87.4, height: 87.4 }} className="origin-center static">
                        <CircularProgressbarWithChildren
                          className="w-[87.4px] h-[87.4px] static"
                          value={0}
                          circleRatio={0.94}
                          styles={buildStyles({
                            rotation: 0.36,
                            strokeLinecap: 'butt',
                            trailColor: 'cream-dark',
                            pathColor: 'gerberared',
                          })}
                        >
                          <div className="relative">
                            <img
                              className="w-[65px] h-[65px]"
                              src={greenEllipse}
                              alt="green circle"
                            />
                            <div className="absolute top-10 right-[-18%]">
                              <img src={fire} width={'21.88'} height={'25px'} alt="fire" />
                            </div>
                          </div>
                        </CircularProgressbarWithChildren>
                      </div>
                      <div className="px-2 py-2 text-center font-primary rounded-[4px] text-base mt-1 text-white bg-primary-active font-medium ">
                        {assessments}
                      </div>
                    </div>
                  )
                })}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Assessment
